import { Link } from 'gatsby'
import * as React from 'react'
import Layout from '../components/layout'
import Seo from '../components/seo'
export default function NotFound() {
    return (
        <div className=" h-[100vh] bg-dark_purple text-center text-white flex items-center flex-col justify-center">
            <h2 className="text-9xl mb-16 text-transparent bg-clip-text bg-gradient-to-br from-pink-400 to-red-400">
                Oops!
            </h2>
            <div className="flex items-center flex-col justify-center">
                <h4 className="text-3xl">404 - PAGE NOT FOUND</h4>
                <p className="max-w-[70%] text-xl my-4">
                    The page you are looking for might have been removed had its
                    name changed or is temporarily unavailable.
                </p>
                <Link
                    className="mt-2 quaternary rounded-full bg-white/10 p-[10.5px_22px_11.5px] text-base text-white font-semibold leading-[18px] hover:bg-white/30 active:bg-white/50 transition duration-200 font-['FoundersGrotesk-Bold']'"
                    to="/"
                >
                    Go to homepage
                </Link>
            </div>
        </div>
    )
}

export const Head = () => (
    <Seo
        title="Page Not Found - Celerity Limited"
        description="Oops! Looks like you've ventured into uncharted territory. Our tech team is on it."
    />
)
